import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getYMDHM, getQuery } from '@src/utils';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import { type FeedFlowItem } from '@src/services/interface';
import { type callAppParmam } from '@src/services/myInterface';

type NoticeResultProps = {
    content: {
        time?: FeedFlowItem['unlockTime'];
        callAppData?: callAppParmam;
    };
};

const NoticeResult = ({ content }: NoticeResultProps) => {
    const unlockTime = content?.time || 0;
    const callAppData = content?.callAppData || {};
    const dateTime = getYMDHM(unlockTime);
    const month = dateTime?.month;
    const date = dateTime?.date;
    const unlockTimeString = `${month}月${date}日`;
    const userId = getQuery(window.location.href, 'userId') || '';
    const wxLaunchHackData = {
        callAppConfig: callAppData,
        statisticsConfig: {
            behavior: 'action',
            type: 'sharepage_app_start',
            button_name: 'd',
            user_id: userId,
        },
    };

    return unlockTime ? (
        <div className={styles.noticeResult}>
            <div className={styles.noticeResultText}>该预言将在{unlockTimeString}前揭晓结果</div>
            <div className={styles.noticeResultButton}>
                <div>通知我结果</div>
            </div>
            <WxLaunchHack content={wxLaunchHackData} />
        </div>
    ) : null;
};

export default errorBoundary(NoticeResult);
